import React from 'react';
import { COLOR_MAP, COLOR_TRANSLATION, COLORI_MAPPINGS } from '../../constants/colorConstants';

const normalizeColorForVisualization = (color) => {
  if (color === 'YE/GN') return 'GI/VE';
  if (COLOR_TRANSLATION[color]) {
    const translated = COLOR_TRANSLATION[color];
    return COLORI_MAPPINGS.it.includes(translated) ? translated : color;
  }
  return color;
};

const CableColorRect = ({
  color,
  width = '20px',
  height = '20px',
  borderRadius = '4px',
  border = '1px solid #ddd',
  className = ''
}) => {
  const normalizedColor = normalizeColorForVisualization(color);
  const isGialloVerde = normalizedColor === 'GI/VE';

  if (isGialloVerde) {
    // Pattern giallo/verde per cavi di terra
    return (
      <div
        className={`overflow-hidden ${className}`}
        style={{
          width,
          height,
          borderRadius,
          border,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{
          width: '100%',
          height: '50%',
          backgroundColor: COLOR_MAP['GIALLO'] || '#FFD600'
        }} />
        <div style={{
          width: '100%',
          height: '50%',
          backgroundColor: COLOR_MAP['VERDE'] || '#4CAF50'
        }} />
      </div>
    );
  } else {
    // Colore solido per tutti gli altri cavi
    const solidColor = COLOR_MAP[normalizedColor] || '#808080';
    return (
      <div
        className={className}
        style={{
          width,
          height,
          borderRadius,
          border,
          backgroundColor: solidColor
        }}
      />
    );
  }
};

export default CableColorRect;

